export const PENDING_REVIEW_AUTOMATION_ACTION =
  'PENDING_REVIEW_AUTOMATION_ACTION'
export const COMPLETED_REVIEW_AUTOMATION_ACTION =
  'COMPLETED_REVIEW_AUTOMATION_ACTION'
